import { useContext } from "react";
import { useLocalization } from "@fluent/react";
import { modules, entities } from "byzantine";
import { Row, TextInput, Select, ResponsiveFlex } from "@narmi/design_system";
import {
  MAX_MEMO_LENGTH,
  useMappedEntryDescription,
} from "byzantine/src/dbbl/businessLogic/modules/achPayments";
import { MAX_BULK_TEMPLATE_TITLE_LENGTH } from "byzantine/src/dbbl/businessLogic/entities/bulkTemplates";
import Account from "byzantine/src/Account";
import * as formAdapters from "../../../../src/adapters";
import ComboAccountSelector from "../../../ComboAccountSelector";
import AccountContext from "../../../contexts/AccountContext";

const TemplateDetailsSection = () => {
  const { l10n } = useLocalization();
  const { accounts } = useContext(AccountContext);
  const form = entities.bulkTemplates.BulkTemplateForm.useForm();
  const codes = modules.achPayments.useSECCodes();
  const { mappedOptions } = useMappedEntryDescription();

  const validAccounts = accounts.filter((account: Account) =>
    account.isValidAchTransferSource()
  );

  return (
    <div>
      <h4 className="fontSize--l nds-sans margin--top--xl margin--bottom--xxs">
        {l10n.getString("bulk-template-details-title", null, "Bulk details")}
      </h4>
      <p className="margin--bottom--l">
        {l10n.getString(
          "bulk-template-details-description",
          null,
          "These details will apply to all of the payments in the bulk payment."
        )}
      </p>
      <ResponsiveFlex gapSize="l">
        <Row>
          <Row.Item>
            <TextInput
              label={l10n.getString(
                "bulk-template-name",
                null,
                "Template name"
              )}
              maxLength={MAX_BULK_TEMPLATE_TITLE_LENGTH}
              {...formAdapters.input(form, "title")}
            />
          </Row.Item>
        </Row>

        <div className="margin--bottom--l">
          <Row>
            <Row.Item>
              <ComboAccountSelector
                label={l10n.getString("label-account")}
                accounts={validAccounts}
                isDestination={true}
                showAddExternalAccountLink={false}
                {...formAdapters.select(form, "fromAccount")}
              />
            </Row.Item>
          </Row>
        </div>

        <div className="margin--bottom--l">
          <Row>
            <Row.Item>
              <Select
                label={l10n.getString(
                  "label-transaction-type-optional",
                  null,
                  "Transaction type (optional)"
                )}
                {...formAdapters.select(form, "secCode")}
              >
                {codes.map((code, index) => (
                  <Select.Item key={`account_type_${index}`} value={code}>
                    {code}
                  </Select.Item>
                ))}
              </Select>
            </Row.Item>
          </Row>
        </div>

        <div className="margin--bottom--l">
          <Row>
            <Row.Item>
              <Select
                label={l10n.getString(
                  "label-entry-description-optional",
                  null,
                  "Entry description (optional)"
                )}
                {...formAdapters.select(form, "entryDesc")}
              >
                {mappedOptions.map(({ display, value }) => (
                  <Select.Item key={value} value={value}>
                    {display}
                  </Select.Item>
                ))}
              </Select>
            </Row.Item>
          </Row>
        </div>

        <Row>
          <Row.Item>
            <TextInput
              label={l10n.getString("label-internal-note-optional")}
              maxLength={MAX_MEMO_LENGTH}
              {...formAdapters.input(form, "description")}
            />
          </Row.Item>
        </Row>
      </ResponsiveFlex>
    </div>
  );
};

export default TemplateDetailsSection;
